import IconOrganization from '@experimental-components/IconsComponents/TopNavBar/Organization';
import Store from '@experimental-components/IconsComponents/TopNavBar/Store';
import Ceal from '@experimental-components/IconsComponents/TopNavBar/Ceal';

import { NavigationType } from './types';

interface Props {
  type: NavigationType;
}

function Icon({ type }: Props) {
  if (type === NavigationType.ORGANIZATION || type === NavigationType.STORE_DRAFT) return <IconOrganization />;
  if (type === NavigationType.STORE) return <Store />;
  if (type === NavigationType.CEAL) return <Ceal />;
  return <></>;
}

export default Icon;
